<template>
    <div class="physio-warp" style="border-top:none;">
        <div class="physio-content" :class="{ 'disabled': isDisabled }">
            <div class="add-warp" v-for="(item, index) in otherItem.items" :key="index">
                <div class="index">
                    <i class="el-icon-plus" v-if="index == otherItem.items.length - 1"></i>
                    <span v-else>{{ index + 1 }}</span>
                </div>
                <div class="select-warp">
                    <el-tooltip v-if="item.inventory != null && item.itemNum > item.inventory && item.onSale == '1'"
                        class="item" effect="dark" content="库存不足" placement="top">
                        <span class="iconfont icon-jingg colorFE8F ml8"></span>
                    </el-tooltip>
                    <el-tooltip v-if="item.onSale == '0'" class="item" effect="dark" content="药品已停售" placement="top">
                        <span class="iconfont icon-tinshou colorF54A ml8"></span>
                    </el-tooltip>
                    <div v-if="item.commodityType === 1" class="other-gift-name">{{ item.itemName }}（赠品）</div>
                    <el-select v-else :disabled="isDisabled || isGroupOrder" :ref="'itemName' + index" v-model="item.itemName"
                        placeholder=" 输入非处方项目或拼音码" remote filterable :remote-method="remoteMethod"
                        @change="selectOther($event, index)" :loading="loading" :popper-append-to-body="false"
                        popper-class="customSelectStyle">
                        <el-option disabled value="1" style="pointer-events:none;background:#F0F1F3;">
                            <span style="width:200px; display:inline-block">项目名称</span>
                            <span style="width:104px; display:inline-block">规格</span>
                            <span style="width: 104px; display:inline-block">类型</span>
                            <span style="width: 100px; display:inline-block">库存</span>
                            <span style="width: 64px; display:inline-block">单位</span>
                            <span style="width: 80px; display:inline-block">价格</span>
                            <span style="width: 70px; display:inline-block">医保属性</span>
                            <span style="width: 80px; display:inline-block">spuId</span>
                        </el-option>
                        <el-option v-for="(obj, index1) in otherOptions" :key="index1" :label="obj.itemName"
                            :value="obj.itemId">
                            <span style="width:200px; display:inline-block">{{ obj.itemName }}</span>
                            <span style="width:104px; display:inline-block">{{ obj.spec }}</span>
                            <span style="width: 104px; display:inline-block">{{ obj.type ? obj.type : '-' }}</span>
                            <span style="width: 100px; display:inline-block">{{ obj.inventory ? obj.inventory : '-' }}</span>
                            <span style="width: 64px; display:inline-block">{{ obj.itemUnit ? obj.itemUnit : '-' }}</span>
                            <span style="width: 80px; display:inline-block">{{ obj.price }}</span>
                            <span style="width:70px; display:inline-block">{{
                                obj.medicalInsuranceType ? computedDictText(obj.medicalInsuranceType,ybPropertyList)
                                : '-'
                            }}</span>
                             <span style="width: 80px; display:inline-block">{{ obj.spuId }}</span>
                        </el-option>
                    </el-select>
                </div>
                <div class="add-right" v-if="index != otherItem.items.length - 1">
                    <div class="edit-warp">
                        <span class="ml5">￥</span>
                        <span>{{ item.price }}</span>
                        <!-- <el-input type="text" disabled v-model="item.price" @change="computeOtherPrice(item)"></el-input> -->
                    </div>
                    <div class="edit-warp" style="text-align: center; width: 30px">
                        <div class="w100_">x</div>
                    </div>
                    <div class="edit-warp" style="width: 50px">
                        <el-input type="text" :disabled="isDisabled || item.commodityType === 1" :ref="'itemNum' + index" v-model="item.itemNum"
                            maxlength="6" @input="formatNum($event, item)" @keydown.enter.native="searchMove(index)"
                            @keydown.down.native.prevent="numberInputMove($event, 'down', index)"
                            @keydown.up.native.prevent="numberInputMove($event, 'up', index)"
                            style="text-align: center"></el-input>
                    </div>
                    <div class="edit-warp" style="text-align: center; width: 30px">
                        <div class="w100_">{{ item.itemUnit }}</div>
                    </div>
                    <div class="edit-warp">
                        <span class="ml5">￥</span>
                        {{ $bigNumber(item.price, '*', item.itemNum, 2) }}
                        <!-- <el-input type="text" disabled v-model="item.totalPrice"></el-input> -->
                    </div>
                    <!-- <div v-if="!isDisabled" class="close-warp" @click="delPhysioProject(index, index)">
                        <i class="el-icon-close"></i>
                    </div> -->
                    <div class="edit-warp">
                        <el-input type="text" :disabled="isDisabled" v-model="item.remark" placeholder="备注" maxlength="50"
                            style="width: 90px" @change="handleOther()"></el-input>
                    </div>
                    <div v-if="!isDisabled" class="edit-warp" style="text-align: center; width: 40px">
                        <div v-if="item.commodityType !== 1" class="w100_" @click="removeOther(index)"><i class="el-icon-close" style="font-size: 16px;"></i></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Outpatient } from "../data/index.js";
import { Utils } from "@/utils/utils";
import { dictText } from '@/utils/validateBase';
import { ybCenterDrugDirectoryCategorySignList,ybPropertyList } from '@/utils/const';
export default {
    components: {},
    props: {
        // 非处方项目
        isGroupOrder: Boolean,
        consultationType: String | Number,
        otherItem: Object,
        isDisabled: Boolean,
        isEdit:Boolean,
    },
    data() {
        return {
            otherOptions: [],
            loading: false,
            ybCenterDrugDirectoryCategorySignList: ybCenterDrugDirectoryCategorySignList,
            ybPropertyList:ybPropertyList
        };
    },
    created() {
        this.computeOtherPrice(1);
    },
    watch: {
        otherItem(newV, old) {
            if (!_.isEmpty(newV.items)) {
                let length = newV.items.filter((val) => val.itemId != "").length;
                if (length > 0) {
                    this.computeOtherPrice(1);
                }
            }
        },
    },
    computed: {
      computedDictText() {
          return function (value,list) {
            return dictText(value, list)
          }
        },
    },
    methods: {
        /**
       * 输入药品用量
       */
        formatNum: _.debounce(function (e, kid) {
            let temp = e.toString();
            temp = temp.replace(/。/g, ".");
            temp = temp.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
            temp = temp.replace(/^\./g, ""); //验证第一个字符是数字
            temp = temp.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
            temp = temp.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
            temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
            kid.itemNum = Number(temp);
            this.computeOtherPrice()
        }, 500),
        remoteMethod(query) {
            if (query !== "") {
                this.loading = true;
                this.getOtherOptions(query);
            } else {
                this.options = [];
            }
        },
        getOtherOptions: _.debounce(function (query) {
            Outpatient.getOtherProject({
              searchWord: query,
              deptId: this.consultationType === 2 ? process.env.VUE_APP_CHAT_DEPT_ID : this.$session.get('deptId'),
              recipeType:0
            }).then((res) => {
              this.loading = false;
              this.otherOptions = res;
            });
        }, 500),
        //选择非处方项目
        selectOther(val, index) {
            let otherItem = _.cloneDeep(this.otherItem);
            let items = otherItem.items;
            let findArr = items.filter((item) => {
                return item.itemId == val;
            });
            if (!_.isEmpty(findArr)) {
                this.$message.error("不可以重复添加");
                items[index].itemId = "";
                items[index].itemName = "";

                this.$emit("updateOtherItem", otherItem);
                return;
            }
            let obj = otherItem.items[index];
            let length = items.length;
            this.otherOptions.forEach((item) => {
                if (item.itemId == val) {
                    obj = { ...obj, ...item };
                    obj.itemNum = 1;
                    obj.onSale='1'
                }
            });
            otherItem.items[index] = obj;
            if (length == 1 || index == length - 1) {
                this.addSearch(otherItem);
            }
            this.otherOptions = [];
            this.otherItem = otherItem
            this.computeOtherPrice();
            this.$nextTick(() => {
                this.$refs[`itemNum${index}`][0].focus()
                this.$refs[`itemNum${index}`][0].select()
            })
            this.$emit("updateOtherItem", otherItem);
        },
        addSearch(otherItem) {
            otherItem.items.push({
                itemId: "",
                itemName: "",
            });
        },
        computeOtherPrice(num) {
            let list = _.cloneDeep(this.otherItem);
            if (_.isEmpty(list.items)) return;
            list.items = list.items.filter((val) => val.itemId != "");
            this.otherItem.items.forEach((val) => {
                val.totalPrice = this.$bigNumber(val.price, "*", val.itemNum);
                val.deleteShow = false
            });
            if (num) return;
            this.handleOther();
        },
        //删除
        removeOther(index) {
            let otherItem = _.cloneDeep(this.otherItem)
            otherItem.items.splice(index, 1);
            this.otherItem = otherItem
            this.computeOtherPrice();
            this.$emit("updateOtherItem", otherItem);
        },
        //保存非处方项目
        handleOther() {
            if (this.isDisabled || this.isEdit) return;
            let obj = _.cloneDeep(this.otherItem);
            obj.items = obj.items.filter((val) => val.itemId != "");
            Outpatient.editPrescription(obj).then((res) => {
                if (!this.otherItem.orderCaseProjectRecipeId) {
                    this.otherItem.orderCaseProjectRecipeId = res.data;
                }
            });
        },
        searchMove(index) {
            this.$nextTick(() => {
                this.$refs[`itemName${index + 1}`][0].focus()
            })
        },
        numberInputMove(e, type, index) {

            switch (type) {
                case 'up':
                    if (Utils.gt(index, 0)) {
                        index--;
                    }
                    this.$refs[`itemNum${index}`][0].focus()
                    this.$refs[`itemNum${index}`][0].select()
                    break;
                case 'down':
                    if (Utils.gt(this.otherItem.items.length - 2, index)) {
                        index++;
                    }
                    this.$refs[`itemNum${index}`][0].focus()
                    this.$refs[`itemNum${index}`][0].select()
                    break;
            }
        },
    },
};
</script>

<style lang="less" scoped>
@borderColor: #E0E0E0;

.physio-warp {
  border: 1px solid #EAEAEA;
  box-sizing: border-box;
  margin-bottom: 20px;
  border-radius: 0 0 4px 4px;
  background: #fff;

  // overflow: hidden;
  .physio-top {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 12px;
    padding-right: 12px;
    box-sizing: border-box;

    .top-left {
      display: flex;
      align-items: center;
      color: #333;
      font-size: 14px;

      .physio-icon {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        flex-grow: 0;
        margin-right: 10px;
      }

      .physio-title {
        color: #000;
        font-size: 14px;
        font-weight: 600;
        margin-right: 34px;
      }
    }

    .top-right {
      // width: 26px;
      display: flex;
      font-size: 14px;
      color: #666;

      .del {
        width: 26px;
        height: 26px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid @borderColor;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 12px;

        .del-icon {
          width: 18px;
          height: 18px;
          cursor: pointer;
        }

        &:hover {
          color: #F54A45;
        }
      }

      .process {
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #E1E1E1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 14px;
        padding: 4px 10px;


      }
    }
  }

  .physio-content {
    .add-warp:last-child {
      .index {
        border-right: 0;
      }
    }

    .add-warp {
      border-top: 1px solid @borderColor;
      display: flex;
      height: 40px;

      &:last-child {
        border-bottom: 0;
      }

      .index {
        width: 32px;
        border-right: 1px solid @borderColor;
        box-sizing: border-box;
        flex-grow: 0;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-icon-plus {
          width: 14px;
          height: 14px;
          color: #999;
        }
      }

      .select-warp {
        padding: 14px 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        /deep/.el-input__inner {
          font-size: 14px;
          font-weight: 600;
          // padding-left: 0;
        }

        /deep/.is-disabled .el-input__inner {
          color: #6c7a8f;
        }

        /deep/.el-select-dropdown__item {
          display: flex;
        }
      }

      .add-right {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #1F2329;

        .close-item {
          padding: 2px;
          background-color: #F0F1F3;
          border-radius: 50%;
          color: rgb(154, 160, 168);
          font-size: 12px !important;
        }

        .price-warp {
          height: 100%;
          color: #667182;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-right: 20px;
          flex-grow: 0;
          flex-shrink: 0;
          // line-height: 40px;
        }

        .edit-warp {
          // color: #6c7a8f;
          width: 128px;
          border-left: 1px solid #E1E1E1;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .item-section {
            color: #667182;
            font-size: 14px;
          }

          .el-input {
            width: 60px;

            /deep/.el-input__inner {
              padding: 0;
              border: none;
              padding-right: 10px;
              text-align: right;
              font-size: 15px;
              color: #1F2329;
            }

          }
        }

        .close-warp {
          width: 40px;
          border-left: 1px dashed #E1E1E1;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .el-icon-close {
            color: #999;
            width: 13px;
            height: 13px;
            font-weight: bold;
          }
        }
      }

    }

    .el-select {
      font-size: 14px;
      color: #000;
      font-weight: 400;
      width: 100%;

      /deep/.el-input__inner {
        border: none;
        font-size: 14px;
      }

      /deep/.el-input__suffix {
        display: none;
      }
    }
  }

  /deep/.is-disabled {
    .el-input__inner {
      background: #FFFFFF;
    }
  }

  /deep/.el-tag {
    font-size: 14px;
  }

  .disabled {
    // pointer-events:none;
    background: #F7F8F9 !important;
    cursor: not-allowed !important;

    /deep/.el-input.is-disabled .el-input__inner {
      background: #F7F8F9 !important;
      color: #1F2329;
    }

    /deep/.el-textarea.is-disabled .el-textarea__inner {
      background: #F7F8F9 !important;
      color: #1F2329;
    }
  }
}

.remarkInput {
  /deep/.el-input__inner {
    height: 36px;
    background: #fff;
    color: #333;
    border: 1px solid transparent;
    border-top: 1px solid #E1E1E1;
  }

  /deep/.el-input__inner:focus {
    border-color: #409EFF;
  }
}

.other-gift-name {
  box-sizing: border-box;
  padding: 0 15px;
  width: 100%;
  font-size: 14px;
  color: #6c7a8f;
}
</style>